"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchToggle = void 0;
const searchToggle = () => {
    const search = document.querySelector('.site-header__search');
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target.matches('[data-toggle="header-search"]'))
            return;
        if (search.getAttribute('aria-hidden') === 'true') {
            target.classList.add('is-active');
            search.setAttribute('aria-hidden', 'false');
            search.querySelector('input').focus();
        }
        else {
            target.classList.remove('is-active');
            search.setAttribute('aria-hidden', 'true');
        }
    });
};
exports.searchToggle = searchToggle;
